import { GoogleTagManagerProvider } from '@/components/GoogleTagManagerProvider'
import { ReactQueryProvider } from '@/components/ReactQueryProvider'
import { GOOGLE_CLIENT_ID } from '@/env'
import { SessionProvider } from '@/features/authorization/components/SessionProvider'
import { Toaster } from '@/ui-kit/components/Sonner'
import { ThemeProvider } from '@/ui-kit/providers'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { StrictMode } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { MissionsLayout } from './MissionsLayout'

export const MissionsApp = () => {
  return (
    <StrictMode>
      <ThemeProvider>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <ReactQueryProvider>
            <GoogleTagManagerProvider />
            <BrowserRouter>
              <SessionProvider>
                <Toaster />
                <MissionsLayout />
              </SessionProvider>
            </BrowserRouter>
            <GoogleTagManagerProvider />
          </ReactQueryProvider>
        </GoogleOAuthProvider>
      </ThemeProvider>
    </StrictMode>
  )
}
